import React, { Component } from "react";
import { withSnackbar } from "notistack";
import { connect } from "react-redux";
import qs from 'qs';
import Constants from 'components/utils/constants'
import mapDispatchToProps from 'reducers/actions/dispatchProps';
import LoadingOverlay from 'components/common/loadingOverlay';
import './authstyle.css';
import { AccountHandler } from "chits-data/dist";

let _this=null;
let host = window.location.hostname;
let port = window.location.port;
let _domain=`https://${host}`;
if (host.includes('localhost') || host.includes('192.168')) {
    _domain = `http://${host}:${port}`;
} else if(host.includes('codecubers.lab')) {
    _domain = `http://${host}`;
} 
class ResetPassword extends Component {
    constructor(props) { 
        super(props) 
        this._handler = new AccountHandler();
        this.handleFieldChange = this.handleFieldChange.bind(this);
        _this = this;
    };

    state = {
        openOverlay: false,
        form: {
            id: '',
            token: '',
            newPassword: '',
            verifyPassword: '',
            domain: _domain
        },
        isMatch: false
    };

    handleFieldChange = (e) => {
        let _form = this.state.form;
        _form[e.target.name] = e.target.value;
        let isMatch = e.target.value && _form['newPassword'] === _form['verifyPassword'];
        this.setState({ form: _form, isMatch });
    }

    handleSubmit = async (e) => {
        e.preventDefault();
        // instance.defaults.headers['Content-Type'] = 'application/json';
        //TODO: handle it as part of form error
        let _form = this.state.form;
        if (_form.newPassword === '' || (_form.newPassword !== _form.verifyPassword)) {
            this.props.enqueueSnackbar('Password is missing or do not match. Please correct.', {
                variant : 'warning'
            });
            return;
        }
        try {
            //console.log(this.props)
            
            // let query = useQuery();
            _form.token = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).token;
			// const {match: {params}} = this.props;
			// if (params) {
                console.log('parameter received:' + JSON.stringify(_form.token));
            //     // _form.id = params.id;
            //     _form.token = params.token;
			// }	
		} catch (error) {
			this.props.enqueueSnackbar('Error: ' + error.message, {
                variant : 'error'
            });
            return;
		}
        this.setState({ openOverlay: true })
        this._handler.getInstance()
            .post(Constants.URLs.AUTH.RESET, _form)
            .then(async (response) => {
                this.setState({ openOverlay: false })
                // console.log(response.data);
                if (response.status !== 200) {
                    this.props.enqueueSnackbar('Error: ' + response.data.msg, {
                        variant : 'error'
                    });
                }
                else {
                    this.props.enqueueSnackbar(response.data.msg, {
                        variant : 'success'
                    });
                    _this.props.history.push("/auth/login");
                }
            })
            .catch((err) => {
                this.setState({ openOverlay: false })
                console.log(err);

                let msg = 'Error: An internal error occured';
                if (err.response && err.response.data && err.response.data.message) {
                    msg = err.response.data.message;
                }
                this.props.enqueueSnackbar(msg, {
                  variant : 'error'
                });
            });
    }

    renderResetForm() {
        return (
          <form
            className="form"
            method="" /* action="" */ /* onSubmit={this.handleSubmit} */
          >
            <div className="card card-reset text-center theme-splash-background">
              <div className="card-header ">
                <div className="row  justify-content-center">
                  <div className="header-text">
                    <h2 className="card-title font-indie-flower-title">Chits</h2>
                    <h6 className="card-subtitle">
                      Chitfund manager by Gumasta.app
                    </h6>
                    <hr />
                    <h3 className="header text-center">Reset Password</h3>
                  </div>
                </div>
              </div>
              <div className="card-body ">
                <div className="card-body">
                  <div className="form-group new-password-field">
                    <label>New Password</label>
                    <input
                      name="newPassword"
                      id="newPassword"
                      type="password"
                      placeholder="New Password"
                      className="form-control"
                      autoComplete="new-password"
                      onChange={this.handleFieldChange}
                    />
                    <i className="bi bi-eye-slash" id="togglePassword1" onClick={()=>{
                      const togglePassword = document.querySelector("#togglePassword1");
                      const password = document.querySelector("#newPassword");
                      // toggle the type attribute
                      const type = password.getAttribute("type") === "password" ? "text" : "password";
                      password.setAttribute("type", type);
                      // toggle the icon
                      togglePassword.classList.toggle("bi-eye");
                    }}></i>
                  </div>
                  <div className="form-group new-password-field">
                    <label>Confirm Password</label>
                    <input
                      name="verifyPassword"
                      id="verifyPassword"
                      type="password"
                      placeholder="Confirm Password"
                      className="form-control"
                      autoComplete="new-password"
                      onChange={this.handleFieldChange}
                    />
                    <i className="bi bi-eye-slash" id="togglePassword2" onClick={()=>{
                      const togglePassword = document.querySelector("#togglePassword2");
                      const password = document.querySelector("#verifyPassword");
                      // toggle the type attribute
                      const type = password.getAttribute("type") === "password" ? "text" : "password";
                      password.setAttribute("type", type);
                      // toggle the icon
                      togglePassword.classList.toggle("bi-eye");
                    }}></i>
                    {this.state.isMatch && <span className="form-check-sign">Passwords Match</span>}
                  </div>
                </div>
              </div>
              <div className="card-footer ml-auto mr-auto">
                <button
                  type="submit"
                  onClick={this.handleSubmit}
                  className="btn btn-warning btn-wd"
                >
                  Submit
                </button>
                <hr />
                <a href="/auth/register">Not a member? Register here</a>
                <hr />
                <a href="/auth/forgotpwd">Forgot Password? Reset here</a>
                <hr />
                <a href="/auth/login">Already a member? Login here</a>
              </div>
            </div>
          </form>
        );
    }

    render() {
        return (
          <div className="container auth-form-container">
            <div className="row">
              <div className="col-md-6 mx-auto auth-panel">
                {this.renderResetForm()}
              </div>
            </div>
            {this.state.openOverlay && <LoadingOverlay />}
          </div>
        )
    }
}

ResetPassword.propTypes = {};

export default connect(null, mapDispatchToProps)(withSnackbar(ResetPassword));